import React, { useCallback, useEffect, useState } from "react";
import { SimpleShowLayout } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import CurriculumModuleAccordion from "./Partials/CurriculumModuleAccordion";
import { useNotifyError } from "utils/useNotifyError";
import { SectionTitle } from "features/SectionTitle";

const SpecialistCurriculumItemSection = ({ specialistId, isTrainingBuildingExternal, statusId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notifyError = useNotifyError();

  const [curriculumData, setCurriculumData] = useState(null);

  const fetchModules = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(specialistRequests.getSpecialistsCurriculumItems(specialistId));
      setCurriculumData(data);
    } catch (err) {
      notifyError(err);
    }
  }, [specialistId, notifyError]);

  useEffect(() => {
    if (!specialistId) return;
    fetchModules();
  }, [specialistId, fetchModules]);

  return (
    <SimpleShowLayout>
      <SectionTitle
        title="Модули и теми за Учебен план"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={3}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          {curriculumData?.modules?.map((module, index) => (
            <CurriculumModuleAccordion
              key={module.id}
              module={module}
              index={index}
              specialistId={specialistId}
              statusId={statusId}
              isTrainingBuildingExternal={isTrainingBuildingExternal}
              fetchModules={fetchModules}
            />
          ))}
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default SpecialistCurriculumItemSection;
